export default __webpack_public_path__ + "static/media/200.20bf6b5c.jpg";